export const isUserTechnician = user => user.glpiactiveprofile === "Técnico";
